var exports = {
  "U": "xa15a2ab7--a8d68b--buttons",
};

module.exports = exports;
